import { ChangeDetectionStrategy, Component, HostBinding, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContentCache } from 'src/core-lib/navigation/services/content-cache.service';
import { UmbracoGrid } from 'src/layout/grid/models/umbraco-grid.type';
import { ContentCacheUtils, StorageUtil } from 'src/utils/storage.util';
import { Language, Languages, MenuConfiguration } from '../../models/main-configuration.model';


@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent implements OnInit {
    @HostBinding('attr.role')
    role = 'contentinfo';
    menu: Partial<MenuConfiguration>;
    blockedPages = ['checkoutPage'];
    pageAlias$: Observable<string>;
    footerContent: UmbracoGrid;

    constructor(
        private contentCache: ContentCache,
        private route: ActivatedRoute,

    ) {
        this.pageAlias$ = this.route.data.pipe(map(p => p?.content?.page?._meta?.alias ?? ''))
    }

    ngOnInit(): void {
        this.menu = StorageUtil.get<MenuConfiguration>('menu');
        this.footerContent = StorageUtil.get<{footerLayout:UmbracoGrid}>('webshopThemeConfig')?.footerLayout ?? [];
    }

    changeLang(event) {
        if ("location" in window)
            window.location.href = event;
    }
}
